'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventDataTable = undefined;

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _uuid = require('d2-utilizr/lib/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDataTable = exports.EventDataTable = undefined;

exports.EventDataTable = EventDataTable = function EventDataTable(refs, layout, response) {
    var t = this;

    var appManager = refs.appManager,
        uiManager = refs.uiManager,
        i18nManager = refs.i18nManager,
        dimensionConfig = refs.dimensionConfig,
        optionConfig = refs.optionConfig;
    var ResponseRowIdCombination = refs.api.ResponseRowIdCombination;


    var i18n = i18nManager.get();

    var FIXED_HEADERS = ['eventdate'];

    var filteredHeaders = response.getFilteredHeaders([].concat(FIXED_HEADERS, layout.getDimensionNames()));

    var rows = response.rows;
    var items = response.metaData.items;
    var cls = [];
    var html = '';

    var pager = response.metaData.pager;
    var count = pager.page * pager.pageSize - pager.pageSize;

    var sortableIdObjects = [];

    cls.push('pivot');
    cls.push(layout.displayDensity !== optionConfig.getDisplayDensity('normal') ? ' displaydensity-' + layout.displayDensity : null);
    cls.push(layout.fontSize !== optionConfig.getFontSize('normal') ? ' fontsize-' + layout.fontSize : null);

    html += '<table class="' + (0, _arrayClean2.default)(cls).join(' ') + '"><tr>';
    html += '<td class="pivot-dim pivot-dim-subtotal">' + '#' + '</td>';

    // get header indexes
    filteredHeaders.forEach(function (header) {
        var uid = (0, _uuid2.default)();

        html += '<td id="' + uid + '" class="pivot-dim td-sortable">' + header.column + '</td>';

        sortableIdObjects.push({
            id: header.name,
            uuid: uid
        });
    });

    html += '</tr>';

    // rows
    for (var i = 0, row, rowHtml; i < rows.length; i++) {
        row = rows[i];
        rowHtml = '';

        for (var ii = 0, header, rowValue, itemKey, name; ii < filteredHeaders.length; ii++) {
            header = filteredHeaders[ii];
            rowValue = row[header.index];

            itemKey = (header.isPrefix ? header.name + '_' : '') + rowValue;

            name = (items[itemKey] || {}).name || rowValue;

            //isBoolean = header.type === 'java.lang.Boolean';
            //str = row[header.index];
            //str = optionNames[header.name + str] || optionNames[str] || (isBoolean ? booleanNames[str] : null) || names[str] || str;
            //name = web.report.query.format(str);

            //if (header.name === 'ouname' && layout.showHierarchy) {
            //var a = Ext.Array.clean(name.split('/'));
            //name = '';

            //for (var k = 0, isLast; k < a.length; k++) {
            //isLast = !!(i === a.length - 1);

            //name += (!isLast ? '<span class="text-weak">' : '') + a[i] + (!isLast ? '</span>' : '') + (!isLast ? ' / ' : '');
            //}
            //}

            rowHtml += '<td class="pivot-value align-left">' + name + '</td>';
        }

        html += '<tr><td class="pivot-value align-right">' + (count + (i + 1)) + '</td>' + rowHtml + '</tr>';
    }

    html += '</table>';

    return {
        sortableIdObjects: sortableIdObjects,
        html: html
    };
};
//# sourceMappingURL=EventDataTable.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/table/EventDataTable.js
 ** module id = 152
 ** module chunks = 0 1
 **/